import * as React from 'react';
import { observer, inject } from 'mobx-react';
import './applicationPageUserInfoPane.module.scss';
import { Pane, PaneBody, PaneBackButton, Page, ContextAwarePaneHeader } from '../../atoms/applications/page';
import { Loader } from '../../atoms/forms/loader';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { CreditCardInputV2 } from '../../molecules/payment/CardInput';
import { ButtonWrapper, SubmitButton } from '../../atoms/forms/vertical/base';
import { PaymentMethodSelector } from '../../molecules/applications/PaymentMethodSelector';
import { BaseApplicationPageState } from '../../../containers/application/states/BaseApplicationPageState';
import { FormError } from '../../../../commonv3/components/atoms/forms/vertical';

type Props = {
  applicationState: BaseApplicationPageState;
};

export const ApplicationPagePaymentInfoPane = inject('applicationState')(
  observer(
    class ApplicationPagePaymentInfoPane extends React.Component<Props> {
      render() {
        const {
          applicationState: {
            name,
            canGoBack,
            cardState,
            applicationPage,
            applicationPageResource,
            entranceInstallments,
            setEntranceInstallments,
            validateCardAndNext,
            entranceFeeItemName,
            submitState: { submitting },
          },
        } = this.props;
        if (applicationPageResource.loading) {
          return <Loader />;
        }
        if (applicationPageResource.isNotFound()) {
          GlobalStatesV3.routing.replace('');
          return <div />;
        }
        const { number, yy, mm, cvc } = cardState.cardFormState.fields;
        return (
          <Page>
            <Pane>
              {canGoBack && <PaneBackButton />}
              <ContextAwarePaneHeader planName={name}>お支払い情報の入力</ContextAwarePaneHeader>
              <PaneBody>
                <CreditCardInputV2 cardState={cardState} />
                {[number, yy, mm, cvc].map((e, i) => (
                  <FormError key={i} state={e} />
                ))}
                {applicationPage.membership_item.price > 0 && (
                  <PaymentMethodSelector
                    title={applicationPage.membership_item.name}
                    price={applicationPage.membership_item.base_price}
                    price_with_tax={applicationPage.membership_item.total_price}
                    value={1}
                    options={[1]}
                  />
                )}
                {applicationPage.entrance_fee_item && (
                  <PaymentMethodSelector
                    id="entrance-fee-selector"
                    title={entranceFeeItemName}
                    price={applicationPage.entrance_fee_item.discount_price}
                    price_with_tax={applicationPage.entrance_fee_item.discount_price_with_tax}
                    value={entranceInstallments}
                    options={applicationPage.entrance_fee_item.options.map((o) => o.installments)}
                    onChange={setEntranceInstallments}
                  />
                )}
                <ButtonWrapper>
                  <SubmitButton id="payment-method-submit" loading={submitting} onClick={validateCardAndNext}>
                    お申し込み内容の確認へ
                  </SubmitButton>
                </ButtonWrapper>
              </PaneBody>
            </Pane>
          </Page>
        );
      }
    }
  )
);
